// client/src/components/feedback/FeedbackForm.js
import { useState } from 'react'
import ApiFeedback from '../../api/ApiFeedback'
import PageLayout from '../common/layout/PageLayout'

function FeedbackForm() {
  const [message, setMessage] = useState('')
  const [status, setStatus] = useState('')

  const handleSubmit = async (e) => {
    e.preventDefault()
    setStatus('')
    try {
      await ApiFeedback.create(message, window.location.href)
      setStatus('Thank you for your feedback!')
      setMessage('')
    } catch (err) {
      setStatus(err.message)
    }
  }

  return (
    <PageLayout title="Feedback">
      <div className="container mt-4" style={{ maxWidth: '600px' }}>
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label htmlFor="feedback" className="form-label">
              Tell us what you think
            </label>
            <textarea
              id="feedback"
              className="form-control"
              rows="5"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              required
            ></textarea>
          </div>
          {status && (
            <div
              className={`mb-3 ${status.includes('Thank you') ? 'text-success' : 'text-danger'}`}
            >
              {status}
            </div>
          )}
          <button type="submit" className="btn btn-primary">
            Submit
          </button>
        </form>
      </div>
    </PageLayout>
  )
}

export default FeedbackForm
